import firebase from 'firebase';


const firebaseConfig = {
    apiKey: "AIzaSyC2CxycQjNNc2fzBegRTp7QmmXnQE6Rf0I",
    authDomain: "clone-pr-bd2af.firebaseapp.com",
    projectId: "clone-pr-bd2af",
    storageBucket: "clone-pr-bd2af.appspot.com",
    messagingSenderId: "438009115039",
    appId: "1:438009115039:web:25a7cefb764fd3d9d8cdaa"
  };

  const firebaseapp =  firebase.initializeApp(firebaseConfig);
  const db = firebaseapp.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();
  export{db,auth,provider};